module.exports = __webpack_public_path__ + "img/dept-5.ab4f2298.svg";